import { bffServiceClient } from 'packages/request/clients';
import {
  IShopBySearchResponse,
  IShopParams,
  IShopWaitingTaskResult,
  IGetNewShopOfStaffParams,
  ITotalShopQRKpiSatisfy,
  IGetListShopApproachResponse,
} from 'interfaces/shop';
import { getData, getResult } from 'helpers/request';
import {
  IGetBaseParams,
  IGetShopTakeCareParams,
  IGetShopTakeCareResponse,
  IGetNewShopsParams,
  IGetNewShopsResponse,
  IGetShopTakeCareStaffResponse,
} from 'interfaces';

const getShops = (params: IShopParams): Promise<IShopWaitingTaskResult> => {
  return bffServiceClient.get('/ticket/waiting', { params }).then(getResult);
};

const getShopsV2 = (params: IShopParams): Promise<IShopWaitingTaskResult> => {
  return bffServiceClient.get('/v2/ticket/waiting', { params }).then(getResult);
};

const getShopBySearch = (params: {
  queryParams?: string;
  page?: number;
  pageSize?: number;
}): Promise<IShopBySearchResponse> => {
  return bffServiceClient
    .get('/shop', {
      params,
    })
    .then(getResult);
};

const getNewShops = (
  params: IGetNewShopsParams
): Promise<IGetNewShopsResponse> => {
  return bffServiceClient
    .get('/shopNewServiceQR/summarize', { params })
    .then(getData);
};

const exportNewShops = (
  params: IGetNewShopsParams
): Promise<{ filePath: string }> => {
  return bffServiceClient
    .get('/shopNewServiceQR/summarizeExport', { params })
    .then(getData);
};

const getNewShopsOfStaff = (
  params: IGetNewShopOfStaffParams
): Promise<IGetNewShopsResponse> => {
  return bffServiceClient.get('/shopNewServiceQR', { params }).then(getData);
};

const getTotalKpiSatisfy = (): Promise<ITotalShopQRKpiSatisfy> => {
  return bffServiceClient
    .get('/shopNewServiceQR/totalKpiSatisfy')
    .then(getData);
};

const getListShopApproach = (
  params: IGetBaseParams
): Promise<IGetListShopApproachResponse> => {
  return bffServiceClient.get('/shop/approach', { params }).then(getData);
};

const changeStatusToAddProfile = (
  merchantId: number,
  payload: { reason: string }
): Promise<{}> => {
  return bffServiceClient
    .put(`/merchant/${merchantId}/reopenMerchantApprovalStatus`, payload)
    .then(getData);
};

const getListShopTakeCare = (
  params: IGetShopTakeCareParams
): Promise<IGetShopTakeCareResponse> => {
  return bffServiceClient
    .get('/shopTakeCare/summarize', { params })
    .then(getData);
};

const getListShopTakeCareStaff = (
  params: IGetNewShopOfStaffParams
): Promise<IGetShopTakeCareStaffResponse> => {
  return bffServiceClient.get('/shopTakeCare', { params }).then(getData);
};

const exportListShopTakeCare = (
  params: IGetShopTakeCareParams
): Promise<{ filePath: string }> => {
  return bffServiceClient
    .get('/shopTakeCare/summarize/export', { params })
    .then(getData);
};

export default {
  getShops,
  getShopsV2,
  getShopBySearch,
  getNewShops,
  exportNewShops,
  getNewShopsOfStaff,
  getTotalKpiSatisfy,
  getListShopApproach,
  changeStatusToAddProfile,
  getListShopTakeCare,
  getListShopTakeCareStaff,
  exportListShopTakeCare,
};
